import React from "react";
import { Box, Stack } from "@mui/material";
import { howAssistedOptions } from "../../medication.config";
import CustomDateField from "../../../../../CustomForm/CustomDate";
import CustomSelect from "../../../../../FormFields/CustomSelect/CustomSelect";
import CustomInput from "../../../../../FormFields/CustomInput";

const MedicationScheduleInfo = ({ formData = {}, handleChange, errors = {} }) => {
  return (
    <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap", gap: 2.5 }}>
      <Box sx={{ flex: "1 1 45%", minWidth: "280px" }}>
        <Stack spacing={2.5}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            <Box sx={{ flex: "1 1 40%", minWidth: "120px" }}>
              <CustomDateField
                label="Start Date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                error={!!errors.start_date}
                helperText={errors.start_date}
                required
                fullWidth
              />
            </Box>
            <Box sx={{ flex: "1 1 40%", minWidth: "120px" }}>
              <CustomDateField
                label="End Date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
                fullWidth
              />
            </Box>
          </Box>

          <CustomSelect
            label="Assistance Level"
            name="how_assisted"
            options={howAssistedOptions}
            value={formData.how_assisted}
            onChange={handleChange}
            error={!!errors.how_assisted}
            helperText={errors.how_assisted}
            fullWidth
            searchPlaceholder="Search assistance level..."
          />
        </Stack>
      </Box>

      <Box sx={{ flex: "1 1 45%", minWidth: "280px" }}>
        <Stack spacing={2.5}>
          <CustomDateField
            label="Medication Expiry Date"
            name="expiry_date"
            value={formData.expiry_date}
            onChange={handleChange}
            error={!!errors.expiry_date}
            helperText={errors.expiry_date}
            fullWidth
          />

          <CustomInput
            label="Every (Days)"
            name="every"
            type="number"
            value={formData.every}
            onChange={handleChange}
            placeholder="e.g., 1, 7, 14"
            fullWidth
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default MedicationScheduleInfo;